import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { APP_VERSION, BUILD_DATE } from './version.js'

console.log(`%c Tony's Liquor Distributor ${APP_VERSION} (${BUILD_DATE}) `, 
  'background: #0e947a; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
